module.exports = __webpack_public_path__ + "static/media/tip_text_cat_twelveweek_fr.0eed1ba3.svg";